export class Disciplinary {
    public static hopMortSciValues = [
        "Administrative Penalty Order",
        "Cease and Desist",
        "Determination Summary",
        "Settlement Orders",
        "Corrective Action"
    ];
}